import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

const playbooksHorizontalNavEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(/* webpackChunkName: "async-spa-apps-playbooks-horizontal-nav" */ './src/index.tsx'),
	),
	getPreloadProps: ({ context: { match } }: EntryPointRouteParams) => {
		// Extract projectKey from route parameters
		const projectKey = match.params.projectKey;

		if (!projectKey) {
			throw new Error('projectKey is required');
		}

		return {
			extraProps: {
				projectKey,
			},
		};
	},
});

export default playbooksHorizontalNavEntrypoint;
